
import { defineComponent, ref } from 'vue'
import portraitImg from '@/assets/tx.png'
import QQGroupQrCode from '@/assets/qq_group_qrcode.jpg'

export default defineComponent({
  setup() {
    const qqInfoDialogvVsible = ref<boolean>(false)
    const swithQQInfoVisible = () => {
      qqInfoDialogvVsible.value = !qqInfoDialogvVsible.value
    }
    return {
      portraitImg,
      swithQQInfoVisible,
      qqInfoDialogvVsible,
      QQGroupQrCode
    }
  },
})
